// HamExpert Portal Theme — brand-inspired indigo/teal palette
export const C = {
  bg: "#0c1133",
  s1: "#141a44",
  s2: "#1b2356",
  s3: "#26306b",
  bd: "#34407e",
  a1: "#3fcfd5",
  a2: "#c0f021",
  a3: "#00a2ff",
  a4: "#7c80f0",
  a5: "#fb7185",
  a6: "#f5ec5a",
  t1: "#eef1ff",
  t2: "#9aa4d4",
  t3: "#5a648f"
};

// Brand gradient used for logos, titles and primary accents
export const BRAND_GRADIENT = "linear-gradient(135deg, #3fcfd5, #00a2ff, #5b5fd6)";

export const CHART_COLORS = [
  C.a1, C.a3, C.a2, C.a4, C.a6, C.a5,
  "#06b6d4", "#8b5cf6", "#22d3ee", "#38bdf8", "#a3e635", "#e879f9"
];

export const tooltipStyle = {
  contentStyle: {
    background: C.s2,
    border: "1px solid " + C.bd,
    borderRadius: 8,
    fontSize: 12,
    color: C.t1
  },
  labelStyle: {
    color: C.a1
  },
  itemStyle: {
    color: C.t1
  }
};
